/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from 'react';

import App from './src/App';
//import FontFaceObserver from 'fontfaceobserver';
import { initSimpleImg } from 'react-simple-img';
import { AppContextProvider } from './src/AppContext';
import { watchVerticalScrollBreakpoints } from 'lib/helpers';


/**
 * Disable prefetching for optimization,
 */
export const disableCorePrefetching = () => true;


/**
 * Wrapping root element with global providers.
 *
 */
export const wrapRootElement = ( { element } ) => (

  <AppContextProvider>
    { element }
  </AppContextProvider>

);


/**
 * Wrapping html with Layout that persists between page transitions.
 */
export const wrapPageElement = ( { element, props } ) => {


  if (typeof window !== 'undefined') {

    require('smooth-scroll')('a[href*="#"]');
    window.FUNCTIONS_URL = process.env.ACTIVE_ENV === 'netlifyDev' ? process.env.FUNCTIONS_URL_DEV : process.env.FUNCTIONS_URL_LIVE;


    // Custom image lazy loading.
    initSimpleImg( { rootMargin: '400px' } );


    window.addEventListener( 'DOMContentLoaded', e => {

      // Production scripts.
      if( process.env.NODE_ENV !== 'production' ) {
        return;
      }

      ( function(e,t,o,n,p,r,i){
        e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};
        e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");
        r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(r,i)
      } )( window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo" );
      window.vgo('setAccount', '799453951');
      window.vgo('setTrackByDefault', true);
      window.vgo('process');

    } );

    // Add login functionality.
    document.onkeyup = e => {

      if(
        ( e.ctrlKey && e.key === 'e' ) ||
        ( e.ctrlKey && e.code === 'Space' )
      ) {
        window.open( 'https://admin.dartdrones.com', '_blank', "height=750,width=400" );

        setTimeout( () => {
          window.location.reload( true );
        }, 2500 );

      }

    }

  }

  // Breakpoints.
  watchVerticalScrollBreakpoints();


  return(

    <App { ...props }>
      { element }
    </App>

  );

};

/**
 * Route updates.
 */
export const onRouteUpdate = ( { location, prevLocation } ) => {



}
